import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { AdModel } from '../../models/ad.model';
@Component({
  selector: 'app-standard-ad-card',
  templateUrl: './standard-ad-card.component.html',
  styleUrls: ['./standard-ad-card.component.scss'],
})
export class StandardAdCardComponent {
  @Input() ad!: AdModel;
  constructor(private router: Router) {}
  public navigateToCampaignLandingPage(campaignUrlId: string): void {
    const url: string = this.router.serializeUrl(
      this.router.createUrlTree([`clp/${campaignUrlId}`])
    );
    window.open(url, '_blank');
  }
}
